import { EProductType } from "../../interfaces/MyPlans/IMyPlans";

export function convertProductType(product_type: EProductType | "") {
  let recurrencyType = product_type || EProductType.FixedQty;
  const recurrencyMap = {
    [EProductType.FixedQty]: "global.product_type.fixed_qty",
    [EProductType.MultipleQty]: "global.product_type.multiple_qty",
    [EProductType.AnalystQty]: "global.product_type.analyst_qty",
    [EProductType.SubAccountsQty]: "global.product_type.sub_accounts_qty",
    "": "global.product_type.desconhecido",
  };
  return recurrencyMap[recurrencyType];
}
